/**
 * @generated SignedSource<<0ed612d68da1304650d111f0fe5dcbea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RateVerificationBannerQuery$variables = {
  membershipTypeId: string;
  rateId: string;
};
export type RateVerificationBannerQuery$data = {
  readonly rateNode: {
    readonly appliesToMembershipType?: boolean | null | undefined;
  } | null | undefined;
};
export type RateVerificationBannerQuery = {
  response: RateVerificationBannerQuery$data;
  variables: RateVerificationBannerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "membershipTypeId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rateId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "rateId"
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "membershipTypeId",
          "variableName": "membershipTypeId"
        }
      ],
      "kind": "ScalarField",
      "name": "appliesToMembershipType",
      "storageKey": null
    }
  ],
  "type": "Rate",
  "abstractKey": "__isRate"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RateVerificationBannerQuery",
    "selections": [
      {
        "alias": "rateNode",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RateVerificationBannerQuery",
    "selections": [
      {
        "alias": "rateNode",
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f2694dce37df66e924c295f58ec573a1",
    "id": null,
    "metadata": {},
    "name": "RateVerificationBannerQuery",
    "operationKind": "query",
    "text": "query RateVerificationBannerQuery(\n  $rateId: ID!\n  $membershipTypeId: ID!\n) {\n  rateNode: node(id: $rateId) {\n    __typename\n    ... on Rate {\n      __isRate: __typename\n      appliesToMembershipType(membershipTypeId: $membershipTypeId)\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1a8564194bdcf881629dd865b422f9a8";

export default node;
